export const LOADER_STATUS = 'gstr2a/LOADER_STATUS';
export const PENDING_INVOICES = 'gstr2a/PENDING_INVOICES';
export const PROFILE_INFO = 'gstr2a/PROFILE_INFO';
export const SUPPLIER_INFO = 'gstr2a/SUPPLIER_INFO';